import { Button } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import MUIDataTable, { TableFilterList } from 'mui-datatables';
import { useEffect, useState } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router';

function useResources() {
  const [resources, setResources] = useState([]);
  useEffect(() => {
    fetch('https://api.edicionesmilenio.com/api/resources')
      .then((response) => response.json())
      .then((json) => {
        let data = json?.data?.map((resource) => {
          return {
            _id: resource?._id,
            title: resource?.title,
            description: resource?.description,
            grade: resource?.grade?.name,
            asignature: resource?.asignature?.name,
          };
        });
        setResources(data);
      });
  }, []);
  return { resources, setResources };
}

function CustomChip({ label, onDelete }) {
  return (
    <Chip
      label={label}
      onDelete={() => {
        onDelete(label);
      }}
      style={{ margin: 2 }}
    />
  );
}

function CustomFilterList(props) {
  return <TableFilterList {...props} ItemComponent={CustomChip} />;
}

export function Resources(props) {
  const { resources, setResources } = useResources();
  const navigate = useNavigate();

  const routeChange = (id) => {
    navigate(`/admin/resources-update/${id}`);
  };

  const columns = [
    {
      name: 'title',
      label: 'Título',
    },
    {
      name: 'description',
      label: 'Descripción',
      options: {
        filter: false,
      },
    },
    {
      name: 'grade',
      label: 'Grado',
    },
    {
      name: 'asignature',
      label: 'Asignatura',
    },
    {
      name: 'actions',
      label: 'Herramientas',
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <Button
              color="primary"
              onClick={() => routeChange(resources[dataIndex]?._id)}
            >
              <FaEdit />
            </Button>
          );
        },
      },
    },
  ];

  const handleDelete = async (rowsDeleted) => {
    const confirm = window.confirm(
      '¿Está seguro que desea eliminar los recursos seleccionados?'
    );
    if (confirm) {
      rowsDeleted?.data?.forEach(async (row) => {
        let response = await fetch(
          `https://api.edicionesmilenio.com/api/resources/${
            resources[row?.dataIndex]?._id
          }`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        let data = await response.json();
        if (data.success) {
          setResources(resources.splice(row?.dataIndex, 1));
        }
      });
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás visualizar la lista de
        recursos creados en la plataforma, puedes usar las herramientas,
        filtrar, buscar, imprimir, descargar, para gestionar este módulo.
      </p>
      <MUIDataTable
        title={'Recursos'}
        data={resources}
        columns={columns}
        options={{
          filterType: 'dropdown',
          onRowsDelete: (rowsDeleted) => {
            handleDelete(rowsDeleted);
          },
        }}
        components={{
          TableFilterList: CustomFilterList,
        }}
      />
    </div>
  );
}
